import { children, JSXElement } from "solid-js"
import styles from './st-alert.module.css';

export type AlertType = 'default' | 'primary' | 'success' | 'info' | 'danger' | 'warning';

export class STAlertParams {
    children: JSXElement;
    type!: AlertType;
}

export default function STAlert(params: STAlertParams) {
    const content = children(() => params.children)

    return <div class={`flexbox horizontal middle ${styles['alert']}`} data-type={params.type}>
        <i style="font-size: 1.4em; margin-right: 10px" class="fas fa-info-circle"></i>
        <div>
            {content()}
        </div>
    </div>
}
STAlert.defaultProps = new STAlertParams();